let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("euz2R")).then(() => parcelRequire('4AnDw'));